import React from "react";
import Icon from '@mdi/react';
import {mdiPlaylistCheck, mdiMapMarkerDistance, mdiMapMarkerRadiusOutline, mdiCog} from '@mdi/js';
import {Link, useParams, useMatches, useSearchParams} from "react-router-dom";
import i18n from "../lang/i18n";

export default function Tabs() {

    const {tripKey} = useParams();
    const [searchParams] = useSearchParams();

    const TourId = searchParams.get('TourId');

    const isActiveTrip = useMatches().find(match => match.id.includes('tab-trip'));
    const isRoute = useMatches().find(match => match.id.includes('tab-route'));
    const isNextStop = useMatches().find(match => match.id.includes('tab-next-stop'));
    const isSettings = useMatches().find(match => match.id.includes('tab-settings'));

    return (
        <footer className="position-fixed bottom-0 w-100 limit-width">
            <div className="row px-0 m-0 bg-primary-container h-100 py-2 align-items-start">
                <Link to={'/' + tripKey + (TourId ? '?TourId=' + TourId : '')} className="col-3 text-center tab-text" style={{textDecoration: 'none'}}>
                    <div className={'tab-icon mx-auto ' + (isActiveTrip ? 'tab-active text-dark rounded-5' : '')}>
                        <Icon path={mdiPlaylistCheck} size={1}/>
                    </div>
                    <p className="mb-0 tab-name"><small>{i18n.t('2529')}</small></p>
                </Link>
                <Link to={'/route/' + tripKey + (TourId ? '?TourId=' + TourId : '')} className="col-3 text-center tab-text" style={{textDecoration: 'none'}}>
                    <div className={'tab-icon mx-auto ' + (isRoute ? 'tab-active text-dark rounded-5' : '')}>
                        <Icon path={mdiMapMarkerDistance} size={1}/>
                    </div>
                    <p className="mb-0 tab-name"><small>{i18n.t('163')}</small></p>
                </Link>
                <Link to={'/next-stop/' + tripKey + (TourId ? '?TourId=' + TourId : '')} className="col-3 text-center tab-text" style={{textDecoration: 'none'}}>
                    <div className={'tab-icon mx-auto ' + (isNextStop ? 'tab-active text-dark rounded-5' : '')}>
                        <Icon path={mdiMapMarkerRadiusOutline} size={1}/>
                    </div>
                    <p className="mb-0 tab-name"><small>{i18n.t('2135')}</small></p>
                </Link>
                <Link to={'/settings/' + tripKey + (TourId ? '?TourId=' + TourId : '')} className="col-3 text-center tab-text" style={{textDecoration: 'none'}}>
                    <div className={'tab-icon mx-auto ' + (isSettings ? 'tab-active text-dark rounded-5' : '')}>
                        <Icon path={mdiCog} size={1}/>
                    </div>
                    <p className="mb-0 tab-name"><small>{i18n.t('1711')}</small></p>
                </Link>
            </div>
        </footer>
    )
}